import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBell = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.2363 25.2126H18.7639C18.7639 26.7389 17.5265 27.9763 16.0001 27.9763C14.4737 27.9763 13.2363 26.7389 13.2363 25.2126Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.9997 4.02359C15.3638 4.02359 14.8483 4.55063 14.8483 5.20076V6.37792C14.8483 6.41058 14.8496 6.44294 14.8522 6.47493C11.5831 7.03374 9.09156 9.93985 9.09156 13.4409V15.745C9.09156 16.2521 8.91205 16.7419 8.5862 17.1241L7.84422 17.9944C5.44154 20.8126 7.39924 25.2126 11.0558 25.2126H20.9436C24.6002 25.2126 26.5579 20.8126 24.1552 17.9944L23.4132 17.1241C23.0874 16.7419 22.9079 16.2521 22.9079 15.745V13.4409C22.9079 9.93981 20.4163 7.03369 17.1472 6.47491C17.1497 6.44292 17.151 6.41058 17.151 6.37792V5.20076C17.151 4.55063 16.6355 4.02359 15.9997 4.02359ZM11.3943 13.4409C11.3943 10.8404 13.4562 8.73225 15.9997 8.73225C18.5432 8.73225 20.6051 10.8404 20.6051 13.4409V15.745C20.6051 16.8208 20.986 17.8602 21.6774 18.6711L22.4194 19.5414C23.5234 20.8364 22.6238 22.8582 20.9436 22.8582H11.0558C9.37558 22.8582 8.476 20.8364 9.58006 19.5414L10.322 18.6711C11.0134 17.8602 11.3943 16.8208 11.3943 15.745L11.3943 13.4409Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgBell);
export default ForwardRef;
